import { Badge } from "@/components/ui/badge";
import { STATUS_TONE } from "./govConfig";

export const StatusBadge = ({ status, testId }) => (
  <Badge variant="outline" className={`whitespace-nowrap font-semibold ${STATUS_TONE[status] || ""}`} data-testid={testId}>
    {status || "—"}
  </Badge>
);
